// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__14a3N","icon":"SortAdornment_icon__Ydonp","up":"SortAdornment_up__RiEa-","down":"SortAdornment_down__1BzY9","active":"SortAdornment_active__1LeZK"};